export const opcoSettings: Record<string, OpcoSettings> = {
  IE: {
    phoneRegex: new RegExp(/^\+353\d{9}$/),
  },
  PT: {
    phoneRegex: new RegExp(/^\+351\d{9}$/),
  },
};

interface OpcoSettings {
  phoneRegex: RegExp;
}
